import GroupDashContainer from "../components/GroupDash/GroupDashContainer";

export default function GroupDash(){
    return <div><GroupDashContainer/></div>
}